import Navigation from "Components/Templates/Navigation/Navigation";
import React from "react";
import styles from './PageTemplate.module.sass';

const PageTemplate = ({
    children
}: Props) => {
    return <div className={styles['pagetemplate']}>
        <Navigation />
        <div className={styles['pagetemplate__content']}>
            { children }
        </div>
    </div>;
}

interface Props {
    children?: any
}

export default PageTemplate;